
// react-bootstrap imports
import { useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { Button, Card, Form, Stack } from "react-bootstrap"

// components imports
import { LoadingSpinner } from "components/Helpers"
import { WarningInvalidInput, WarningIncompleteInput } from "components/AlertMessages"

import { formatDate } from "services/FormFunctions"
import { getFormData } from "services/FormFunctions"
import { PegarProcesso } from "services/CallAPIs"

import stdStyle from "json/StdStyles.json"
import * as Links from "constants/links"
import "index.css"
import { section } from "services/InputFieldsGuia"
import { TIPO } from "constants/tiposDoc"

const CardGuiaPagamento = ({ processo, guiaData, guiaUsada }) =>
{
    const navigate = useNavigate()
    function redirect()
    {
        navigate(Links.GERAR_DOCUMENTO, {state:
            {
                editar: false,
                procData: processo,
                guiaData: guiaData,
                guiaUsada: guiaUsada,
                statePrevPage: undefined,
                linkPrevPage: Links.MEUS_DOCUMENTOS
            }})
    }

    return (
            <Card
                key={"Primary"}
                text={'dark'}
                className="shadow mb-3 bg-body-tertiary rounded"
                >
                <Button variant="light" onClick={redirect}>
                    <Card.Header className="bg-white">Guia de Pagamento</Card.Header>
                    <Card.Body>
                        <Card.Title>{guiaData.fatoGerador}</Card.Title>
                        <Card.Text className="my-2">{"Valor: "}{guiaData?.taxas?.taxaTotal}</Card.Text>
                        <Card.Text className="my-2">{"Criada em: "}{formatDate(guiaData?.createdAt)}</Card.Text>
                    </Card.Body>
                </Button>
            </Card>
    )
}

const CardGuiaPagamentoMS = ({ processo, guiaData, guiaUsada }) =>
{
    const navigate = useNavigate()
    function redirect()
    {
        navigate(Links.PROCESSO_SERVICOS, {state:
            {
                editar: false,
                procData: processo,
                guiaData: guiaData,
                guiaUsada: guiaUsada,
                statePrevPage: undefined,
                linkPrevPage: Links.MEUS_DOCUMENTOS
            }})
    }

    return (
            <Card
                key={"Primary"}
                text={'dark'}
                className="shadow mb-3 bg-body-tertiary rounded"
                >
                <Button className="bg-danger border-danger" variant="light" onClick={redirect}>
                    <Card.Header >Guia de Pagamento</Card.Header>
                    <Card.Body className="btn btn-danger">
                        <Card.Title>{guiaData.fatoGerador}</Card.Title>
                        <Card.Text className="my-2">{"Valor: "}{guiaData?.taxas?.taxaTotal}</Card.Text>
                        <Card.Text className="my-2">{"Criada em: "}{formatDate(guiaData?.createdAt)}</Card.Text>
                    </Card.Body>
                </Button>
            </Card>
    )
}

export function EscolhaGuiaScreen(processo, guias, guiasUsadas)
{
    if (!guias) { console.log("Erro: Guias é indefinido em EscolhaGuiaScreen") ; return <></> }

    return (
            <Stack direction="vertical" className="mx-auto my-auto mb-4 p-3 text-center shadow border border-dark rounded-3" gap={2}>
                <p className="fw-bold fs-4">Selecione a guia</p>
                {
                    0 < guias.length
                    ? guias.map((guia, index) => <>
                        <CardGuiaPagamento key={guia.id} processo={processo} guiaData={guia} guiaUsada={guiasUsadas[index]} />
                        {guia.detalhesGuia?.tipoDocDestino === TIPO.AutObrasInfra ? <CardGuiaPagamentoMS key={guia.id + "-MS"} processo={processo} guiaData={guia} guiaUsada={guiasUsadas[index]} /> : <></>}
                    </>)
                    : <p className="fs-5 my-auto">Não há guias neste processo<br />(exceto protocolo de entrada)</p>
                }
            </Stack>
        )
}

async function handleSubmit(event, setGuias, setGuiasUsadas, setProcesso, setLoading, setShowAlertInputsAreNotValid, setShowErrorLogin)
{
    event.preventDefault()
    const form = event.currentTarget
    const formData = getFormData(form)
    
    if (!form.checkValidity())
    {
        setShowAlertInputsAreNotValid(true)
    }
    if (!form.checkValidity()) { return }

    setLoading(true)

    const processo = await PegarProcesso(formData?.numProc, formData?.anoProc)

    if (processo)
    {
        setProcesso(processo)
        const docs = processo.documentos

        const guias = docs.filter(guia => guia?.tipoDoc === "GuiaPag")
                        .filter(guia => !guia?.fatoGerador.includes("Protocolo de Entrada"))
                        .filter(guia => !guia?.fatoGerador.includes("Certidão de Retificação de Endereço e Número"))
                        // Documentos do urbDocs
                        // .filter(guia => !guia?.fatoGerador.includes("Certidão de Regularização"))
                        // .filter(guia => !guia?.fatoGerador.includes("Certidão de Habite-se"))
                        // .filter(guia => !guia?.fatoGerador.includes("Habite-se fora do prazo"))

        const idsGuiasUsadas = docs.map(doc => doc?.idGuiaOrigem)

        const guiasUsadas = guias.map(guia => idsGuiasUsadas.includes(guia?.id))

        setGuias(guias)
        setGuiasUsadas(guiasUsadas)
    }
    else
    {
        setShowErrorLogin(true)
    }
        
    setLoading(false)
    
}

export function EscolhaProcessoScreen()
{
    const [guias, setGuias] = useState(undefined)
    const [guiasUsadas, setGuiasUsadas] = useState(undefined)
    const [processo, setProcesso] = useState([])
    const [isLoading, setLoading] = useState(false)
    const [showAlertInputsAreNotValid, setShowAlertInputsAreNotValid] = useState(false)
    const [showErrorLogin, setShowErrorLogin] = useState(false)
    const target = useRef(null)

    const submitForm = async event =>
    {
        handleSubmit(event, setGuias, setGuiasUsadas, setProcesso, setLoading, setShowAlertInputsAreNotValid, setShowErrorLogin)
    }

    if (guias)
    {
        return EscolhaGuiaScreen(processo, guias, guiasUsadas)
    }

    return (
        <>

            <WarningIncompleteInput show={showAlertInputsAreNotValid} setShow={setShowAlertInputsAreNotValid} />
            <WarningInvalidInput show={showErrorLogin} setShow={setShowErrorLogin} messages={["Processo não encontrado"]} />

            <Form className={stdStyle.form} noValidate onSubmit={submitForm}>
                
                <p>Selecione o processo</p>
                { section.dadosProcesso() }
                
                <Button className="mt-3" type="submit" ref={target}>Buscar guias</Button>

            </Form>

            <LoadingSpinner show={isLoading} />
            
        </>
    )

}